/**
 *
 * Task
 *
 */
import NoPermissionsCard from 'app/components/NoPermissionsCard/NoPermissionsCard';
import React from 'react';
import { useSelector } from 'react-redux';
import { generatePath, Redirect, Route, Switch } from 'react-router-dom';
import { RouteConstants } from '../../routes';
import { selectPermissions } from '../Authorization/slice/selectors';
import CreateOrUpdateTask from './pages/CreateOrUpdateTask/CreateOrUpdateTask';
import RoutesWithoutTaskPage from './pages/RoutesWithoutTaskPage/RoutesWithoutTaskPage';
import TaskDetails from './pages/TaskDetails/TaskDetails';
import TaskListPage from './pages/TaskListPage/TaskListPage';
import TaskProgressUpdate from './pages/TaskProgressUpdate/TaskProgressUpdate';

interface Props {}

export function Task(props: Props) {
  const { taskAdministration } = useSelector(selectPermissions);
  if (taskAdministration === 0) {
    return <NoPermissionsCard />;
  }

  return (
    <Switch>
      <Route path={RouteConstants.task.list} component={TaskListPage} />

      <Route
        path={RouteConstants.task.routesWithoutTask}
        component={RoutesWithoutTaskPage}
      />

      <Route
        path={RouteConstants.task.createTask}
        component={CreateOrUpdateTask}
      />
      <Route
        path={RouteConstants.task.detailsOpenedFromFieldTasks}
        component={TaskDetails}
      />
      <Route path={RouteConstants.task.details} component={TaskDetails} />

      <Route
        path={RouteConstants.task.editTask}
        component={CreateOrUpdateTask}
      />
      <Route
        path={RouteConstants.task.taskProgressUpdate}
        component={TaskProgressUpdate}
      />
      <Route
        exact
        path={RouteConstants.task.index}
        render={props => (
          <Redirect
            to={generatePath(RouteConstants.task.list, {
              envId: Number(props.match.params.envId),
            })}
          />
        )}
      />
    </Switch>
  );
}
